<template>
  <CheckoutContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CheckoutContent from "../../components/Payment/PaymentContent.vue";

export default defineComponent({
  name: "PaymentPage",
  components: {
    CheckoutContent,
  },
});
</script>